'use strict';

angular.module('planDeliverableModule', [
]);